import _reduce from 'lodash/reduce';
import _identity from 'lodash/identity';

export const formatListData = (list: any, idKey = '_id', dataFormatter: (a: any) => any = _identity) => {
	return _reduce(
		list,
		(formattedData: any, singleRowData: any, index: any) => {
			const formattedSingleRowData = dataFormatter(singleRowData);
			const newFormattedData = formattedData;

			newFormattedData[index] = {
				...formattedSingleRowData,
				id: formattedSingleRowData[idKey],
				index: index + 1
			};
			return newFormattedData;
		},
		[]
	);
};

export const formatPrevTournamentListData = (list: any, tournamentList: any) => {
	for (let i = 0; i < list.data.length; i += 1) {
		tournamentList.push({
			previousCsv: {
				url: list.data[i].signedUrl,
				path: list.data[i].copiedPath,
				createdAt: new Date(list.data[i].createdAt),
				user: list.data[i].user,
				status: list.data[i].status,
				logs: list.data[i].logs,
				mainFile: list.data[i].mainFile,
				startTime: new Date(list.data[i]?.logs?.startTime),
				endTime: new Date(list.data[i]?.logs?.endTime),
				executionTime: list.data[i]?.logs?.executionTime / 1000,
				gameName: list.data[i].gameName,
				docId: list.data[i].docId,
				preProd: list.data[i].preProd,
				iAmApprover: list.iAmApprover,
				newCsvData: list.data[i].newCsvData,
				oldCsvData: list.data[i].oldCsvData
			},
			currCsv: {}
		});
	}
	return tournamentList;
};

export const formatPrevQuestionBankListData = (
	list: {
		rowCount: number;
		data: any;
		iAmApprover: boolean;
	},
	questionBankList: any
) => {
	return questionBankList.append(
		...list.data.map((d: any) => ({
			previousCsv: {
				url: d.signedUrl,
				path: d.copiedPath,
				createdAt: new Date(d.createdAt),
				user: d.user,
				status: d.status,
				logs: d.logs,
				mainFile: d.mainFile,
				startTime: new Date(d?.logs?.startTime),
				endTime: new Date(d?.logs?.endTime),
				executionTime: d?.logs?.executionTime / 1000,
				gameName: d.gameName,
				docId: d.docId,
				preProd: d.preProd,
				iAmApprover: list.iAmApprover,
				newCsvData: d.newCsvData,
				oldCsvData: d.oldCsvData
			},
			currCsv: {}
		}))
	);
};

export const dehydrateListData = (selectedDataCollection: any) =>
	_reduce(
		selectedDataCollection,
		(dataList: any, dataValue: any) => {
			const { rowData } = dataValue;
			const newRowData = rowData;
			delete newRowData.id;
			dataList.push(newRowData);
			return dataList;
		},
		[]
	);
/**
 * collection of
 * {
 *    columnKey,
 *    filterLabel,
 *    filterValue
 *
 *  }
 * @param {*} filterCollection
 *
 * returns a collection of initial filters to be directly consumed by data list
 */

export const createInitialFilters = (filterCollection: any) =>
	_reduce(
		filterCollection,
		(filters, filter) => {
			const { columnKey, filterLabel, filterValue } = filter;
			const selectionSet = new Set([filterValue]);
			filters.set(columnKey, {
				description: filterLabel,
				selection: selectionSet
			});
			return filters;
		},
		new Map()
	);

export default { formatListData, dehydrateListData, createInitialFilters };
